import { gatewayClient } from 'utils/gatewayClient';

export interface FetchConnectedAccountsResponse {
  data: Array<{
    id: string;
    name: string;
    accountType: string;
    accountLastFour: string;
    isPrimary: boolean;
    status: string;
  }>;
}

export const fetchConnectedAccounts = ({
  status,
}: {
  status?: Array<string>;
}) => {
  const statuses = status?.join(',');
  return gatewayClient.get('/banking/v1/member/reimbursement-targets', {
    params: { status: statuses },
  });
};

export const createConnectedAccount = ({
  plaidPublicToken,
  plaidAccountId,
  verificationStatus,
  accountHolderLegalName,
}: {
  plaidPublicToken: string;
  plaidAccountId: string;
  verificationStatus: string;
  accountHolderLegalName: string;
}) =>
  gatewayClient.post('/banking/v1/member/reimbursement-targets', {
    plaidPublicToken,
    plaidAccountId,
    verificationStatus,
    accountHolderLegalName,
  });

export const createConnectedAccountToken = (args: {
  reimbursementTargetId?: string;
}): Promise<{
  linkToken: string;
  expiration: string;
}> =>
  gatewayClient.post('/banking/v1/member/reimbursement-targets/token', args);

export const verifyConnectedAccount = ({
  connectedAccountId,
  verificationStatus,
  accountHolderLegalName,
}: {
  connectedAccountId: string;
  verificationStatus: string;
  accountHolderLegalName: string;
}) =>
  gatewayClient.put(
    `/banking/v1/member/reimbursement-targets/${connectedAccountId}/verify`,
    {
      verificationStatus,
      accountHolderLegalName,
    }
  );

export const deleteConnectedAccount = ({
  reimbursement_target_id,
}: {
  reimbursement_target_id: string;
}) =>
  gatewayClient.delete(
    `/banking/v1/member/reimbursement-targets/${reimbursement_target_id}`
  );
